<template>
    <v-container>

        <div class="display-2 mb-3">Table of contents</div>
        <div class="mb-10">
            <ul class="TOC">
                <li>
                    <a href="#Introduction">Introduction</a>
                </li>
                <li>
                    <b>APIs</b>
                    <ul>
                        <li v-for="(submenus,group) in menus" :key="group">
                            <a :href="`#${group}`" class="text-capitalize">{{ group }}</a>
                            <ul>
                                <li v-for="(name,key) in submenus" :key="key">
                                    <a :href="`#${key}`" class="text-capitalize">{{ name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li>
                    <a href="#code-examples">Code Examples</a>
                    <ul>
                        <li><a href="#code-example-php">PHP</a></li>
                        <li><a href="#code-example-nodejs">Node.js</a></li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="mb-10">
            <div class="display-1"><a name="Introduction"></a>Introduction</div>
            <introduction></introduction>
        </div>

        <div class="display-1">APIs</div>
        <api-docs-group
            v-for="group in groups"
            :key="group"
            :group="group"
            :config="config"
        ></api-docs-group>


        <div class="mb-10">
            <div class="display-1"><a name="code-examples"></a>Code Examples</div>
            <code-examples></code-examples>
        </div>

    </v-container>
</template>

<script>
    import ApiDocsGroup from "./ApiDocsGroup";
    import Introduction from "./Intruduction";
    import CodeExamples from "./CodeExamples";

    export default {
        name: "ApiDocs",
        components: {
            ApiDocsGroup,
            Introduction,
            CodeExamples,
        },
        props: {
            config: {
                type: Array,
                required: true,
            }
        },
        computed: {
            api_names() {
                let names = [];
                this.config.map((c) => {
                    names.push(c.name);
                });

                return names;
            },
            groups() {
               let hash = {};
               this.api_names.map((n) => {
                   let g = n.split(".")[0];
                   if (typeof hash[g] === 'undefined')
                       hash[g] = true;
               });

               return Object.keys(hash);
            },
            menus() {
                let menus = {};

                this.groups.map((group) => {
                    menus[group] = {};

                    this.config.map((c) => {
                        if (c.name.startsWith(`${group}.`)) {
                            menus[group][c.name] = c.name.replace(/_/g, ' ');
                        }
                    });
                });

                return menus;
            },
        },
    }
</script>

<style scoped>
    ul.TOC > li {
        margin-bottom: 12px;
    }

</style>